import type { BaseOptionType } from "antd/lib/select"

/**
 * `Project.LeadSource.NONE` — a real stored value, not an absence, so a lead
 * without an identified source still counts in source reporting and is not
 * blocked from progressing.
 */
const LEAD_SOURCE_NONE = "none"
const LEAD_SOURCE_NONE_LABEL = "None"

// The option is served by `/crm/leads/filter_options/`; this only covers the
// window in which a deployed frontend is ahead of the backend that adds it.
function withNoneSourceOption(
  options: BaseOptionType[] | undefined
): BaseOptionType[] {
  const sourceOptions = options ?? []

  return sourceOptions.some((option) => option?.value === LEAD_SOURCE_NONE)
    ? sourceOptions
    : [
        { value: LEAD_SOURCE_NONE, label: LEAD_SOURCE_NONE_LABEL },
        ...sourceOptions
      ]
}

export { LEAD_SOURCE_NONE, LEAD_SOURCE_NONE_LABEL, withNoneSourceOption }
